import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useCommonPersistentStore } from '@src/shared/store/common-persistent-store';
import React, { ReactNode, useEffect } from 'react';

interface componentProps {
  bottomSheetView?: boolean;
  popupView?: boolean;
  bottomSheetWrapper: (
    content: ReactNode,
    overrideBlockingValue?: boolean | undefined
  ) => ReactNode;
  popupWrapper: (content: ReactNode) => ReactNode;
  content: ReactNode;
}

const QRCodeContentViewWrapper = ({
  bottomSheetView,
  popupView,
  content,
  bottomSheetWrapper,
  popupWrapper,
}: componentProps) => {
  const { isResolutionMobile } = useDeviceDetect();
  const { OCFTutorialIsActive } = useCommonPersistentStore();

  if (!bottomSheetView && !popupView) {
    return <>{content}</>;
  }

  if (!isResolutionMobile) {
    if (popupView) {
      return <>{popupWrapper(content)}</>;
    }
    return <>{content}</>;
  } else {
    if (bottomSheetView) {
      return <>{bottomSheetWrapper(content, OCFTutorialIsActive ? false : undefined)}</>;
    }
    return <>{content}</>;
  }
};

export default QRCodeContentViewWrapper;
